export default __webpack_public_path__ + "static/media/confidence-logo.f824f29c.svg";